import React from 'react'
import Navbar from '../components/navbar'
import Footer from '../components/footer'

export default function PrivacyPolicy() {
  return (
    <>
      <Navbar navLight={false} playBtn={false} bgLight={false} navCenter={false} />

      <section className="relative md:py-24 py-16 bg-slate-50/50 dark:bg-slate-800/20 mt-16">
        <div className="container relative max-w-4xl">
          <h1 className="mb-4 md:text-4xl text-3xl font-bold">Política de Privacidad – KnowYourBody</h1>

          <p className="text-slate-500 mb-1">
            <strong>Fecha de entrada en vigor:</strong> 8 de marzo de 2026
          </p>
          <p className="text-slate-500 mb-6">
            <strong>Última actualización:</strong> 8 de marzo de 2026
          </p>

          <div className="space-y-6 text-slate-600">
            <p>
              Esta Política de Privacidad describe cómo <strong>KnowYourBody</strong> (en adelante, la “Aplicación”) recopila, usa, almacena y comparte información cuando usas la app.
            </p>
            <p>
              Si tienes dudas sobre esta política, puedes contactarnos en: <strong>[contacto@gmdeveloper.cl]</strong>.
            </p>

            <div>
              <h2 className="text-2xl font-semibold mb-3">1. Responsable del tratamiento</h2>
              <ul className="list-disc ps-6 space-y-2">
                <li><strong>Nombre del responsable:</strong> [GaryMeliman]</li>
                <li><strong>Correo de contacto:</strong> [contacto@gmdeveloper.cl]</li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-semibold mb-3">2. Información que recopilamos</h2>
              <p className="mb-3">Dependiendo de cómo uses la Aplicación, podemos recopilar:</p>
              <ul className="list-disc ps-6 space-y-2">
                <li><strong>Datos de cuenta e identificación:</strong> nombre, correo electrónico, UID de usuario y credenciales de acceso gestionadas por Firebase Authentication.</li>
                <li><strong>Contenido generado por el usuario:</strong> ejercicios, rutinas, mensajes de chat, imágenes y/o videos que el usuario cargue o capture dentro de la app.</li>
                <li><strong>Datos técnicos y de uso:</strong> información del dispositivo, sistema operativo, identificadores técnicos, eventos de uso y diagnósticos.</li>
                <li><strong>Datos de errores y rendimiento:</strong> reportes de fallos y métricas técnicas para estabilidad de la app.</li>
                <li><strong>Notificaciones:</strong> token de notificaciones push y preferencias relacionadas.</li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-semibold mb-3">3. Permisos de Android que utilizamos</h2>
              <p className="mb-3">La app puede solicitar los siguientes permisos:</p>
              <ul className="list-disc ps-6 space-y-2">
                <li><strong>Cámara (android.permission.CAMERA):</strong> para capturar imágenes o video desde la app (por ejemplo, al crear o adjuntar contenido de ejercicios).</li>
                <li><strong>Micrófono (android.permission.RECORD_AUDIO):</strong> para grabar audio cuando la funcionalidad de captura de video/audio lo requiera.</li>
                <li><strong>Almacenamiento/medios (READ_EXTERNAL_STORAGE, READ_MEDIA_VIDEO, WRITE_EXTERNAL_STORAGE):</strong> para seleccionar, leer o guardar archivos multimedia necesarios para funciones de la app.</li>
                <li><strong>Notificaciones (POST_NOTIFICATIONS):</strong> para enviar avisos relevantes de la aplicación.</li>
              </ul>
              <p className="mt-3">La app solo intenta acceder a estos recursos cuando la funcionalidad lo requiere y, cuando corresponde, solicita autorización previa al usuario.</p>
            </div>

            <div>
              <h2 className="text-2xl font-semibold mb-3">4. Finalidades del tratamiento</h2>
              <p className="mb-3">Usamos la información para:</p>
              <ul className="list-disc ps-6 space-y-2">
                <li>Proveer y mantener las funciones principales de la app.</li>
                <li>Permitir autenticación, gestión de perfiles y sincronización de contenido.</li>
                <li>Facilitar la comunicación entre usuarios (por ejemplo, chat en tiempo real).</li>
                <li>Subir, almacenar y mostrar contenido multimedia asociado al uso de la plataforma.</li>
                <li>Mejorar seguridad, rendimiento y experiencia de usuario.</li>
                <li>Cumplir obligaciones legales y prevenir usos indebidos o fraudulentos.</li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-semibold mb-3">5. Base legal (cuando aplique)</h2>
              <p className="mb-3">Tratamos datos con base en:</p>
              <ul className="list-disc ps-6 space-y-2">
                <li>El <strong>consentimiento</strong> del usuario (por ejemplo, permisos del dispositivo).</li>
                <li>La <strong>ejecución del servicio</strong> solicitado por el usuario.</li>
                <li>El <strong>interés legítimo</strong> de mejorar seguridad, estabilidad y funcionamiento.</li>
                <li>El <strong>cumplimiento de obligaciones legales</strong>.</li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-semibold mb-3">6. Servicios de terceros</h2>
              <p className="mb-3">Para operar la Aplicación utilizamos proveedores que pueden procesar datos en nuestro nombre, como:</p>
              <ul className="list-disc ps-6 space-y-2">
                <li><strong>Google Firebase</strong> (Authentication, Firestore, Storage, Analytics, Crashlytics, Cloud Messaging).</li>
              </ul>
              <p className="mt-3 mb-2">Estos proveedores aplican sus propias medidas de seguridad y políticas de privacidad. Puedes consultar:</p>
              <ul className="list-disc ps-6">
                <li>Firebase / Google Privacy: https://policies.google.com/privacy</li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-semibold mb-3">7. Compartición de datos</h2>
              <p className="mb-3">No vendemos datos personales. Solo compartimos datos cuando es necesario para:</p>
              <ul className="list-disc ps-6 space-y-2">
                <li>Prestar el servicio mediante proveedores tecnológicos.</li>
                <li>Cumplir requerimientos legales de autoridades competentes.</li>
                <li>Proteger derechos, seguridad y operación de la plataforma.</li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-semibold mb-3">8. Conservación de datos</h2>
              <p className="mb-3">Conservamos los datos durante el tiempo necesario para cumplir las finalidades descritas, salvo que la ley exija o permita un plazo mayor.</p>
              <p>Cuando solicites la eliminación de cuenta o contenido, aplicaremos los procesos de borrado o anonimización conforme a nuestras obligaciones técnicas y legales.</p>
            </div>

            <div>
              <h2 className="text-2xl font-semibold mb-3">9. Seguridad</h2>
              <p>Implementamos medidas técnicas y organizativas razonables para proteger la información contra acceso no autorizado, pérdida o alteración. Sin embargo, ningún sistema es 100% infalible.</p>
            </div>

            <div>
              <h2 className="text-2xl font-semibold mb-3">10. Derechos del usuario</h2>
              <p className="mb-3">Según tu jurisdicción, puedes tener derecho a:</p>
              <ul className="list-disc ps-6 space-y-2">
                <li>Acceder a tus datos.</li>
                <li>Rectificar datos inexactos.</li>
                <li>Solicitar eliminación de datos.</li>
                <li>Oponerte o limitar determinados tratamientos.</li>
                <li>Retirar el consentimiento otorgado.</li>
              </ul>
              <p className="mt-3">Para ejercer estos derechos, escribe a: <strong>[contacto@gmdeveloper.cl]</strong>.</p>
            </div>

            <div>
              <h2 className="text-2xl font-semibold mb-3">11. Menores de edad</h2>
              <p>La Aplicación no está dirigida a menores de edad sin supervisión o autorización válida cuando la legislación lo requiera. Si detectamos datos de menores recabados de forma indebida, tomaremos medidas para eliminarlos.</p>
            </div>

            <div>
              <h2 className="text-2xl font-semibold mb-3">12. Transferencias internacionales</h2>
              <p>Algunos proveedores pueden procesar información en países distintos al tuyo. En esos casos, procuramos que existan salvaguardas adecuadas de protección de datos.</p>
            </div>

            <div>
              <h2 className="text-2xl font-semibold mb-3">13. Cambios a esta política</h2>
              <p>Podemos actualizar esta Política de Privacidad ocasionalmente. Publicaremos la versión vigente con su fecha de actualización dentro de este mismo documento.</p>
            </div>

            <div>
              <h2 className="text-2xl font-semibold mb-3">14. Contacto</h2>
              <p className="mb-3">Si tienes preguntas, solicitudes o reclamos sobre privacidad, contáctanos:</p>
              <ul className="list-disc ps-6 space-y-2">
                <li><strong>Correo:</strong> [contacto@gmdeveloper.cl]</li>
                <li><strong>Responsable:</strong> [GaryMeliman]</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  )
}
